import type { LoginRequest } from '../../domain/models/user'
import type { ILogin } from '../../domain/use-cases/i-login'

export class LoginController {
  constructor(private readonly repository: ILogin) {}
  async login(params: LoginRequest) {
    try {
      const result = await this.repository.login(params)
      return result
    } catch (error) {
      throw error
    }
  }
}
